module.exports = __webpack_public_path__ + "static/content-02-11cc978f96cb0842edeb4693566a7cf7.jpg";